import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {useForm} from "react-hook-form";
import {ButtonMain, InputMain, PageLoader, SwitchMain} from "components";
import {httpRequestsOnSuccessActions, payerActions} from 'store'
import {Svg} from 'assets'
import {FindLoad, FindSuccess} from "utils";

const ACTION_TYPE_GET = 'GET_MOMENTM_PAYER'
const ACTION_TYPE_CONNECT = 'CONNECT_MOMENTM_PAYER'
const ACTION_TYPE_EDIT = 'EDIT_MOMENTM_PAYER'

export const Integrations = ({currentId}) => {
    const [connect, setConnect] = useState(false);
    const momentm = useSelector((state) => state.payers?.momentm);
    const ACTION_TYPE = momentm ? ACTION_TYPE_EDIT : ACTION_TYPE_CONNECT;
    const {control, reset, handleSubmit, watch} = useForm();
    const dispatch = useDispatch();
    const loading = FindLoad(ACTION_TYPE_GET);
    const success = FindSuccess(ACTION_TYPE);
    const loadingConnect = FindLoad(ACTION_TYPE);
    const status = watch('status')

    useEffect(() => {
        if (success?.type) {
            dispatch(httpRequestsOnSuccessActions.removeSuccess(ACTION_TYPE));
            setConnect(false)
        }
    }, [success]);

    useEffect(() => {
        if (momentm?.id) {
            const {id, ...rest} = momentm;
            reset({
                ...rest,
                status: rest?.status === 'ACTIVE'
            })
        } else {
            reset({
                username: '',
            }, {
                keepValues: false,
                keepDefaultValues: false,
            });

        }
    }, [momentm]);

    useEffect(() => {
        dispatch(payerActions.getMomentmToPayer(currentId))
    }, [dispatch]);

    const toggleSwitch = () => {
        dispatch(payerActions.editMomentmStatus(currentId, {status: status ? 'INACTIVE' : 'ACTIVE'}))
    }


    const onSubmit = (data) => {
        const params = {
            password: data?.password,
            username: data?.username,
            status: data?.status
        }

        if (momentm) {
            dispatch(payerActions.editMomentmToPayer(currentId, params))
        } else {
            params.payer = currentId
            dispatch(payerActions.connectMomentmToPayer(params))
        }
    }

    return (
        <div className="payer-integrations-wrapper" style={{height: loading?.length ? 328 : ''}}>
            {!!loading?.length ?
                <PageLoader wrapperHeight="100%" height="100%"/>
                :
                <div className='payer-integrations-box'>

                    <p className='payer-integrations-title'>Momentm Integration</p>

                    <div className='payer-integration-connect-momentm-wrapper'>
                        <div className='payer-integration-connect-momentm-header'>
                            <p className='payer-integration-connect-momentm-title'>
                                Momentm
                            </p>

                            {(!connect && !momentm?.id) &&
                                <ButtonMain
                                    type='button'
                                    text='Connect'
                                    buttonMainStyles={{
                                        width: 97,
                                        height: 36,
                                        padding: '6px 16px',
                                    }}
                                    onClick={() => setConnect(true)}
                                />
                            }

                            {(!connect && momentm?.id) &&
                                <div className='flex-gap-16' style={{width: 'fit-content'}}>
                                    <button
                                        className='payer-integration-connect-momentm-edit-btn'
                                        type='button'
                                        onClick={() => setConnect(true)}
                                    >
                                        <Svg.EditInfoSvg/>
                                    </button>

                                    <SwitchMain
                                        name='status'
                                        control={control}
                                        styleWrapper={{padding: 0}}
                                        onChange={toggleSwitch}
                                    />
                                </div>
                            }
                        </div>

                        {connect &&
                            <form
                                className='payer-integration-connect-momentm-body'
                                onSubmit={handleSubmit(onSubmit)}
                            >
                                <div className='flex-gap-16'>
                                    <InputMain
                                        name="username"
                                        placeholder="Enter Username"
                                        control={control}
                                        labelHeader="Username"
                                        rules={{
                                            required: "Username is required",
                                        }}
                                    />

                                    <InputMain
                                        type='password'
                                        name="password"
                                        placeholder="Enter Password"
                                        control={control}
                                        labelHeader="Password"
                                        rules={{
                                            required: "Password is required",
                                        }}
                                    />
                                </div>

                                <div className="flex-gap-16" style={{justifyContent: 'flex-end'}}>
                                    <ButtonMain
                                        text="Cancel"
                                        cancel
                                        buttonMainStyles={{
                                            width: "fit-content",
                                        }}
                                        onClick={() => setConnect(false)}
                                    />
                                    <ButtonMain
                                        text='Connect'
                                        load={!!loadingConnect?.length}
                                        type="submit"
                                        buttonMainStyles={{
                                            width: "113px",
                                        }}
                                    />
                                </div>
                            </form>
                        }
                    </div>
                </div>
            }
        </div>
    );
};

